import '../../plugin';
import '../../filter';
import '../../plugin/pre-save';
import './style.scss';
import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import save from './save';
import deprecated from './deprecated';
import metadata from './block.json';
import variations from './variations';
import { dispatch } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

const { name, attributes, supports } = metadata;

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType( name, {
	attributes,

	variations,

	deprecated,

	supports,

	/**
	 * @see ./edit.js
	 */
	edit: Edit,

	/**
	 * @see ./save.js
	 */
	save,
} );

/**
 * Add our custom entities for retrieving external setting and variable data.
 *
 * @since 2.5.0
 */
dispatch( 'core' ).addEntities( [
	{
		label: __( 'Popper Patterns', 'popper' ),
		kind: 'popper/v1',
		name: 'patterns',
		baseURL: '/popper/v1/patterns',
	},
] );

document.addEventListener( 'DOMContentLoaded', function () {
	if ( 'popper' === window.pagenow ) {
		// Your code to run since DOM is loaded and ready
		const menuRoot = document.querySelector( '#toplevel_page_popper' );
		menuRoot.classList.remove( 'wp-not-current-submenu' );
		menuRoot.classList.add(
			'wp-has-current-submenu',
			'wp-menu-open',
			'current'
		);
		menuRoot.querySelector( '.wp-first-item' ).classList.add( 'current' );
	}
} );
